import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useFormState} from "react-final-form";

function useSelectedFeature() {
    const {values} = useFormState();
    const optionFeatures = useSelector(state => state.orderOptions.data.features);
    const [features, setFeatures] = useState([]);

    useEffect(() => {
        let data = [];
        Object.keys(optionFeatures).map(key => {
            if (values[key]) {
                data.push(optionFeatures[key]);
            }
        });

        setFeatures(data);
    }, [values]);

    return features
}

export default useSelectedFeature